export default __webpack_public_path__ + "static/media/AirAsia_X_Logo.915c029c.svg";